/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect,} from 'react';
import { Box, Button, CircularProgress, InputLabel,  Typography } from '@mui/material';
import InputController from '../../../components/InputController/InputController';
import { useForm } from 'react-hook-form';
import CustomToast from '../../../components/Toast/CustomToast';
import useToast from '../../../hooks/useToast';
import { yupResolver } from '@hookform/resolvers/yup';
import { resetEmailSchema } from '../../../schemas/PasswordResetSchema';
import useMasterApi from '../../../services/useMasterApi';
import { ENDPOINT } from '../../../services/endPoints';
import { useNavigate } from 'react-router-dom';
import PATH from '../../../router/params';

const PasswordReset = (props) => {
    const { handlePasswordReset} = props;
    const navigate = useNavigate();
    const { handleSubmit, control, formState: {errors, isDirty, isValid }, reset} = useForm({
        defaultValues:{
          email_id: "",
        },
        resolver: yupResolver(resetEmailSchema),
      });
  const { toastMessage, toast, toastType, setToast, showToast } = useToast()
  const {post, data, error, loading} = useMasterApi();



  const onSubmit = (data)=>{
    localStorage.setItem("email", data.email_id);
    post(ENDPOINT.RESET_EMAIL_LINK, {...data, user_type: "1", "resend_email": "0" })
    reset();
  };

  useEffect(()=>{
    if(data){
      if(data.success){
        showToast("success", "Password Reset Email Sent Successfully")
        setTimeout(()=>{
          navigate(PATH.CHECK_EMAIL, {replace: true});
        },1500)
       
      }
      if(error){
        showToast("error", error.data.error)
      }
    }
  },[data, error])

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
    <Box
      sx={{ display:"flex", flexDirection: "column", gap: "1rem", maxWidth:"550px", mx:"auto" }}
    >
      <Box sx={{textAlign:"center"}}>
                   <Typography variant="h1" fontWeight="bold" color={(theme)=>theme.palette.secondary.main}>
                      Welcome <Box sx={{display: "inline", color: (theme)=>theme.palette.aqua.main}}>Back!</Box>
                   </Typography>
                <Typography  sx={{mt:1, fontWeight:"600"}} color={(theme)=>theme.palette.secondary.main}>
                   Health Care
                 </Typography>
            </Box> 

          <InputLabel sx={{fontSize: "1.5rem",  color:(theme)=>theme.palette.primary.main}}>Forgot Password?</InputLabel>

    <InputController
                     name="email_id"
                     label="Email"
                     control={control}
                     errors={errors}
                     mainLogin
                     />
      <Button variant="contained" type="submit" disabled={loading}>
         {loading ? <CircularProgress/> : "Send Password Reset Email"}
      </Button>
      <Typography variant="body2" color="error" sx={{textAlign:"right", cursor: "pointer",
                         }} onClick={handlePasswordReset}>
                     Sign In
                     </Typography>
      {toast && <CustomToast 
        open={toast}
        toastMessage={toastMessage}
        setToast={setToast}
        toastType={toastType}
      />}
    </Box>
    </form>
    
  );
};

export default PasswordReset;